import Vue from 'vue';
import {VueReCaptcha} from 'vue-recaptcha-v3';
import {Constants} from '@/const';
import debounce from 'debounce';

// This needs to be here instead of main.ts because of watermark present on page.
Vue.use(VueReCaptcha, {
	siteKey: Constants.recaptchaSiteKey,
});

export default Vue.extend({
	props: {
		/**
		 * The category id
		 */
		categoryId: {
			required: true,
			type: Number,
		},
	},
	data() {
		return {
			/**
			 * True if submit is attempted at least once. Used to show errors.
			 */
			isAttemptedSubmission: false,
			/**
			 * True when form is being submitted to server
			 */
			isSubmitting: false,
			/**
			 * True when form is submitted successfully
			 */
			isSubmittSuccess: false,
			/**
			 * The form data
			 */
			formData: {} as any,
			/**
			 * submitErrors
			 */
			errors: {
				/**
				 * Main error message, next to submit-btn
				 */
				message: '',
				/**
				 * Errors for each input
				 */
				keys: {} as any,
			},
		};
	},
	methods: {
		/**
		 * Event for submitting using "Send"-button only.
		 */
		async onTrySubmitForm() {
			this.isAttemptedSubmission = true;
			this.isSubmitting = true;

			try {
				const recaptchaToken = await this.$recaptcha('homepage');

				const submitResult = await this.$store.dispatch('submitContactForm', {
					recaptchaToken,
					data: {
						formData: this.formData,
						contactFormId: this.contactForm.id,
					},
				});

				this.isSubmittSuccess = true;
			} catch (e) {
				// Validation error
				if (e.response.status === 400) {
					// this.errors.message = this.$t('Vennligst rett feil i skjema, og deretter send inn på nytt');
					this.errors.keys = e.response.data;
				} else {
					this.errors.message = this.$t('unknown_error').toString();
				}
			} finally {
				this.isSubmitting = false;
			}
		},
		/**
		 * Initiates form input-data at initial load
		 */
		initiateForm() {
			this.formData = {};
			this.contactForm.items.forEach((item: any) => {
				if (item.type.toString().endsWith('List')) {
					Vue.set(this.formData, item.id, {
						values: [],
						item,
					});
				} else {
					Vue.set(this.formData, item.id, {
						values: [],
						item,
					});
				}
			});
		},
		/**
		 * Checks if input has to show errors
		 * @returns {boolean} True if errors should be showed.
		 */
		inputHasErrors(item: any) {
			return this.isAttemptedSubmission && this.errors.keys[item.id] != null;
		},
		/**
		 * Whenever input changes after submit, it is being validated on server.
		 */
		onInputChange: debounce(async function(this: any) {
			if (this.isAttemptedSubmission) {
				const response = await this.$store.dispatch('getContactFormErrors', this.formData);
				this.errors.keys = response.data;
			}
		}, 500),
		/**
		 * Gets label id, is unique
		 * @param item The item
		 */
		getLabelId(item: any): string {
			return `contact-form-label-${item.id}`;
		},
		/**
		 * Gets label class by type
		 * @param item The item
		 */
		getLabelClass(item: any): string {
			return `contact-form-label-${item.type}`;
		},
		/**
		 * Gets label id, is unique
		 * @param item The item
		 */
		getInputId(item: any): string {
			return `contact-form-input-${item.id}`;
		},
		/**
		 * Gets input class by type
		 * @param item The item
		 */
		getInputClass(item: any): string {
			let cls: string = '';
			if (this.inputHasErrors(item)) {
				cls += 'is-invalid';
			}
			return `${cls} contact-form-input-${item.type}`;
		},
		/**
		 * Gets input option id
		 * @param item The item
		 * @param item The item option
		 */
		getInputOptionId(item: any, option: any) {
			return `contact-form-input-${item.id}-option-${option.id}`;
		},
		/**
		 * Gets input option class by type
		 * @param item The item
		 * @param item The item option
		 */
		getInputOptionClass(item: any, option: any) {
			return `contact-form-input-${item.type}`;
		},
		/**
		 * Initiates click on back btn after form is successfully submitted.
		 */
		onFeedbackBackBtn() {
			this.isSubmittSuccess = false;
			this.initiateForm();
		},
	},
	computed: {
		contactForm(): any {
			return this.$store.getters.contactFormByCategoryId(this.categoryId);
		},
	},
	created() {
		this.initiateForm();
	},
});
